// extracted by css-extract-rspack-plugin
export default {"disabled":"RSKWWJjU","checkboxInput":"LV1dCdYx","checkboxIndicator":"XsxqMTA5","checkboxTickWrap":"dMfq6GeR","checkboxLabel":"wlkCWXfO","switchInputBlock":"sK0zoeLd"};